import { createAction, props } from '@ngrx/store'
import { ReportCache } from 'core-lib';

export const loadCache = createAction(
    '[CACHE] Load Report Cache',
    props<{ cacheKey: string }>()
);

export const loadCacheSuccess = createAction(
    '[CACHE] Load Report Cache Success',
    props<{ cache: ReportCache }>()
);

export const loadCacheFail = createAction(
    '[CACHE] Load Report Cache Fail',
    props<any>()
);
